{
  "name": "frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve:staging": "ng serve --configuration=staging-local --proxy-config=proxy.staging.conf.json",
    "serve:review": "node scripts/serve-review.mjs",
    "build": "ng build -c ${ANGULAR_BUILD_CONFIGURATION:-production}",
    "build:staging": "ng build -c staging",
    "build:prod": "ng build -c production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint --fix",
    "format": "prettier --write \"src/**/*.{ts,html,less,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,less,json}\"",
    "generate:api-types": "tsx scripts/openapi-camelize.ts && openapi-typescript ../api/openapi.camel.json -o src/app/api/schema/schema.ts --root-types",
    "prepare": "husky",
    "scalingo-prebuild": "cp .npmrc.example .npmrc",
    "postinstall": "npm --prefix ../libs/jsonlogic-interpreter ci --include=dev && npm --prefix ../libs/jsonlogic-interpreter run build:front"
  },
  "lint-staged": {
    "*.{js,ts,jsx,tsx,html}": [
      "prettier --write",
      "eslint --fix"
    ],
    "*.{css,less,json}": [
      "prettier --write"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/build": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/cli": "21.2.17",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/router": "21.2.17",
    "@datadog/browser-rum": "7.3.0",
    "@datadog/browser-rum-angular": "7.3.0",
    "@fnccr-actee/design-system": "1.8.2",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "camelcase-keys": "10.0.2",
    "rxjs": "7.8.2",
    "snakecase-keys": "9.0.2",
    "tslib": "2.8.1",
    "typescript": "5.9.3",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "21.2.17",
    "@emnapi/core": "1.9.2",
    "@emnapi/runtime": "1.9.2",
    "@types/jasmine": "5.1.13",
    "@types/node": "25.6.0",
    "angular-eslint": "21.3.1",
    "camelcase": "9.0.0",
    "eslint": "9.39.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.4",
    "husky": "9.1.7",
    "jasmine-core": "5.12.1",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "less": "4.4.2",
    "lint-staged": "16.2.7",
    "openapi-typescript": "7.13.0",
    "prettier": "3.9.6",
    "prettier-plugin-organize-imports": "4.3.0",
    "tsx": "4.21.0",
    "typescript-eslint": "8.50.1"
  }
}
